module.exports = __webpack_public_path__ + "static/media/logoYandex.081bf927.png";